import { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import LayoutGeneral from "../LayoutGeneral";
import { RUTAS_BITACORAS, RUTAS_INCIDENCIAS } from "../Rutas";
import "./IncidenciaNueva.css";
import DatePicker from "react-datepicker";

const IncidenciaNueva = () => {
    const navigate = useNavigate();
    const idUsuario = localStorage.getItem('idUsuario');
    const EsAdmin = localStorage.getItem("admin");
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    const rolUsuario = roles.length > 0 ? roles[0].idRol : null;
    const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);
    // Tipo Incidencia
    const [tipoIncidencia, setTipoIncidencia] = useState([]);
    const [tipoIncidenciaSeleccionada, settipoIncidenciaSeleccionada] = useState("")
    // Usuarios Empleados
    const [empleados, setEmpleados] = useState([]);
    const [EmpleadoSeleccionado, setEmpleadoSeleccionado] = useState("")
    //Fecha de incidencia
    const [fechaInicioIncidencia, setFechaInicioIncidencia] = useState(null);
    const [fechaFinIncidencia, setFechaFinIncidencia] = useState(null);
    // Función para cerrar sesión
    const cerrarSesion = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("idUsuario");
        localStorage.removeItem("nombreUsuario");
        navigate("/");
    };
    // Redireccionamientos
    const GoHome = () => { navigate("/Home"); };
    const GoUsuarios = () => { navigate("/Usuarios"); };
    const GoBitácoras = () => { navigate("/Bitacoras"); };
     const GoIncidencias = () => { navigate("/Incidencias"); };

    // Función para sanitizar texto y escapar caracteres especiales
    const sanitizarTexto = (texto) => {
        if (!texto) return "";
        return String(texto)
            .replace(/\\/g, "\\\\")  // Escapa backslash
            .replace(/"/g, '\\"')     // Escapa comillas dobles
            .replace(/'/g, "\\'")     // Escapa comillas simples
            .replace(/\n/g, "\\n")    // Escapa saltos de línea
            .replace(/\r/g, "\\r")    // Escapa retorno de carro
            .replace(/\t/g, "\\t");   // Escapa tabulaciones
    };

    // Cargar datos iniciales
    useEffect(() => {
        // Traer incidencias
        const fetchIncidencia = async () => {
            try {
                const res = await fetch(RUTAS_INCIDENCIAS.GET_TIPO_INCIDENCIA);
                const data = await res.json();
                console.log(data);
                setTipoIncidencia(data);
            } catch (error) {
                console.error("Error cargando roles:", error);
            }
        };
        fetchIncidencia();
        //Traer Empleados
        const fetchEmpleados = async () => {
            try {
                const id_usuario = localStorage.getItem("idUsuario")
                const res = await fetch(RUTAS_INCIDENCIAS.GET_EMPLEADOS(id_usuario));
                const data = await res.json();
                console.log(data);
                setEmpleados(data);
            } catch (error) {
                console.error("Error cargando roles:", error);
            }
        };
        fetchEmpleados();


    }, []);
const formatearFecha = (fecha) => {
    if (!fecha) return "";

    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const dia = String(fecha.getDate()).padStart(2, "0");

    return `${dia}/${mes}/${anio}`;
};
    //   useEffect(() => {
    //     const fetchBitacora = async () => {
    //       try {
    //         const res = await fetch(RUTAS_BITACORAS.GET_BITACORAID(idBitacora));
    //         const data = await res.json();
    //         setBitacora(data);
    //         setAcuerdos(data.acuerdos || []);
    //         console.log("Bitácora cargada:", data , idBitacora);
    //       } catch (error) {
    //         console.error("Error al cargar la bitácora:", error);
    //       }
    //     };
    //     fetchBitacora();
    //   }, [idBitacora]);

    const guardarIncidencia= async (e) => {
        e.preventDefault();

        // if (!validateForm()) {
        //     alert("Completa todos los campos obligatorios.");
        //     return;
        // }
        //const fechaFormateada = fechaActividad ? `${fechaActividad.getFullYear()}-${String(fechaActividad.getMonth()+1).padStart(2,'0')}-${String(fechaActividad.getDate()).padStart(2,'0')} ${horaContacto}` : "";
        const fechaSistema = new Date().toISOString();
        const modelo = {
          IdInicidencia:0,
          idUsuario: EmpleadoSeleccionado.value ? Number(EmpleadoSeleccionado.value) : 0,
          idTipoIncidencia: tipoIncidenciaSeleccionada ? Number(tipoIncidenciaSeleccionada) : 0,
          tipoIncidencia:"",
          fechaInicio:  formatearFecha(fechaInicioIncidencia),
          fechaFin:  formatearFecha(fechaFinIncidencia),         
          estatus: 1,
          fechaCreacion: fechaSistema,  
          usuarioCreador: Number(idUsuario),
          Nombre:""
        };
        try {
            console.log("MODELO:", modelo);
console.log("JSON:", JSON.stringify(modelo));
console.log("EmpleadoSeleccionado:", EmpleadoSeleccionado);
          const res = await fetch(RUTAS_INCIDENCIAS.REGISTER_INICIDENCIA, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(modelo)
          });
    
          if (res.ok) {
            alert("Incidencia guardada correctamente.");
            navigate("/Incidencias");
          } else {
            const error = await res.text();
            alert("Error al guardar la incidencia: " + error);
          }
        } catch (error) {
          alert("Error de conexión: " + error.message);
        }
    };
const hoy = new Date();

const hace5Dias = new Date();
hace5Dias.setDate(hoy.getDate() - 5);

    return (
        <LayoutGeneral titulo="IncidenciaNueva">
            <div className="home-container">
                 <aside className="sidebar">
                <ul>
                    <li onClick={GoHome}><i className="bi bi-house"></i> Inicio</li>
                    {EsAdmin === "1" && (
                      <li onClick={GoUsuarios}><i className="bi bi-people"></i> Usuarios</li>
                    )}
                     {puedeVerReporte && (
                            <li onClick={GoIncidencias}><i className="bi bi-people"></i> Incidencias</li>
                        )}
                    <li onClick={GoBitácoras}><i className="bi bi-journal"></i> Bitácoras</li>
                    <li className="logout" onClick={cerrarSesion}> <i className="bi bi-box-arrow-right"></i> Cerrar Sesión </li>
                </ul>
                </aside> 

                <main className="main-content">
                    <h2>
                        <button className="btn btn-primary mt-3" onClick={GoIncidencias}>
                            Regresar
                        </button>
                        <center> <span> Nueva Incidencia </span> </center>
                    </h2>

                    <form className="nueva-Bitacora-form" onSubmit={guardarIncidencia}>
                        {/* Renglon #1 */}
                        <div className="col-md-5">
                            <label> Tipo de Incidencia</label>
                            <select className="form-control" value={tipoIncidenciaSeleccionada || ""} onChange={(e) => settipoIncidenciaSeleccionada(e.target.value)}
                            >
                                <option value=""> Seleccione un tipo de incidencia</option>
                                {tipoIncidencia.map((item) => (
                                    <option
                                        key={item.idIncidencia} value={item.idIncidencia}>
                                        {item.incidencia}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-5">
                            <label>Nombre del Empleado </label>
                            <Select
                                options={empleados.map(p => ({
                                    value: p.idUsuario,
                                    label: p.nombre,
                                }))}
                                value={EmpleadoSeleccionado}
                                onChange={(opcion) => setEmpleadoSeleccionado(opcion)}
                                placeholder="Seleccione un empleado"
                                isClearable
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Fecha de Inicio</label>
                            <DatePicker
                                selected={fechaInicioIncidencia}
                                onChange={date => setFechaInicioIncidencia(date)}
                                className="form-control w-100"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Selecciona una fecha"
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={30}
                                minDate={hace5Dias}
                            />
                          </div>
                          <div className="col-md-4">
                            <label>Fecha de Fin</label>
                            <DatePicker
                                selected={fechaFinIncidencia}
                                onChange={date => setFechaFinIncidencia(date)}
                                className="form-control w-100"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Selecciona una fecha"
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={30}
                                minDate={fechaInicioIncidencia || hace5Dias}
                            />
                          </div>
                           {/* Botón de Guardar Incidencia */}
                        <div className="d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary">
                                Guardar Incidencia
                            </button>
                        </div>
                    </form>

                </main>
            </div>
        </LayoutGeneral>
    );

};
export default IncidenciaNueva;